/*
  One segmented strip, drawn the same wherever a screen offers a short row of alternatives.

  Two callers, and they are deliberately not the same element. The wedstrijddag detail pane
  switches *panels*, which is what ARIA tabs are for - so it stays Radix `Tabs`, and keeps the
  tab-to-panel relationship and the arrow-key walk that come with it (ADR-0064). The accounts
  filter switches which rows a list *queries*; there is no panel, so it is a row of toggle
  buttons and says so with `aria-pressed`. Announcing "tab 1 of 3" for something that reveals no
  tabpanel is the kind of tidy that only a sighted reader benefits from.

  What they share is the look, which is all that was ever different about them. Hence class
  strings rather than a component: a wrapper would have to take either shape and would end up
  being one of them badly.

  The active arm is written twice because the two elements say "active" differently - Radix sets
  `data-state`, a toggle button sets `aria-pressed`. Both selectors carry an attribute beyond the
  class, so each beats the plain `hover:` arm on specificity and the order here does not matter.
*/

/** The row itself. Wraps rather than scrolling sideways: a label off the edge is a hidden one. */
export const segmentedStrip = "flex flex-wrap items-center gap-1";

/** One arm of the strip. Sized and focused like `Button` at `size="sm"`, so the row sits in a toolbar. */
export const segmentedItem = [
  "inline-flex h-8 shrink-0 items-center justify-center gap-1.5 rounded-md px-3",
  "text-sm font-bold whitespace-nowrap transition-all outline-none",
  "focus-visible:ring-[3px] focus-visible:ring-ring/45 active:translate-y-px",
  "disabled:pointer-events-none disabled:opacity-45",
  "hover:bg-accent",
  "data-[state=active]:bg-secondary data-[state=active]:text-secondary-foreground",
  "data-[state=active]:hover:bg-secondary-hover",
  "aria-pressed:bg-secondary aria-pressed:text-secondary-foreground",
  "aria-pressed:hover:bg-secondary-hover",
].join(" ");
